var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_315073)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.0001 50.0085C38.8072 50.0085 50.0001 38.9698 50.0001 25.3529C50.0001 11.736 38.8072 0.697266 25.0001 0.697266C11.193 0.697266 9.15527e-05 11.736 9.15527e-05 25.3529C9.15527e-05 38.9698 11.193 50.0085 25.0001 50.0085Z",
    fill: "url(#paint0_radial_4655_315073)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1141 8.20996C14.2425 8.20996 5.43243 16.8987 5.43243 27.6139C5.43243 38.3292 14.2425 47.0245 25.1141 47.0245C35.9858 47.0245 44.7891 38.3358 44.7891 27.6139C44.7891 16.8921 35.979 8.20996 25.1141 8.20996ZM25.1141 42.5014C16.7741 42.5014 10.0188 35.8391 10.0188 27.6139C10.0188 19.3888 16.7741 12.7331 25.1141 12.7331C33.4542 12.7331 40.2028 19.3954 40.2028 27.6139C40.2028 35.8325 33.4475 42.5014 25.1141 42.5014Z",
    fill: "url(#paint1_linear_4655_315073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1129 11.3818C16.0208 11.3818 8.64767 18.6534 8.64767 27.6136C8.64767 36.5739 16.0208 43.852 25.1129 43.852C34.205 43.852 41.5714 36.5805 41.5714 27.6136C41.5714 18.6467 34.1983 11.3818 25.1129 11.3818ZM25.1129 42.501C16.7728 42.501 10.0175 35.8388 10.0175 27.6136C10.0175 19.3885 16.7728 12.7328 25.1129 12.7328C33.4529 12.7328 40.2015 19.3951 40.2015 27.6136C40.2015 35.8322 33.4462 42.501 25.1129 42.501Z",
    fill: "url(#paint2_linear_4655_315073)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23371 15.5405C9.02554 16.4478 10.9393 17.9643 11.2751 18.1431C11.6108 18.3286 16.0495 11.0504 25.1147 11.3815C34.18 11.706 39.0081 18.1564 39.364 18.4213C39.7199 18.6862 42.003 18.1497 42.003 18.1497C42.003 18.1497 37.1615 7.77227 25.4102 8.08352C13.6589 8.40141 9.23371 15.5405 9.23371 15.5405Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8069 12.0517C29.3973 11.9457 32.4929 9.31659 32.7279 9.42255C32.963 9.52851 36.8845 11.502 37.6433 12.3894C38.4021 13.2769 37.3076 16.3563 37.3009 16.3497C37.2941 16.3431 34.9573 13.3629 29.8002 12.0517H29.8069Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8177 19.5562C10.8177 19.5562 16.4986 12.7284 25.1139 12.7284C33.7293 12.7284 39.6116 19.9205 39.6116 19.9205C39.6116 19.9205 34.4747 11.3774 25.3489 11.3774C16.2232 11.3774 10.8177 19.5562 10.8177 19.5562Z",
    fill: "#74742F"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7721 29.5728C8.7721 29.5728 7.38881 23.6257 10.9948 19.2549C10.9948 19.2549 8.61766 22.7781 8.7721 29.5728Z",
    fill: "#614E43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1457 15.2184C36.0315 15.1257 37.1059 14.8608 37.3611 15.086C37.6163 15.3112 37.3611 16.4105 37.3611 16.4105C37.3611 16.4105 36.3001 15.3509 36.1457 15.2184Z",
    fill: "#5C493D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8187 17.3569C10.2009 17.2709 9.42194 15.6748 10.4695 14.1781C11.517 12.6814 14.0956 11.4563 15.2103 11.1649C16.3317 10.8735 15.2237 14.1185 14.2366 15.4298C13.2495 16.7411 10.8254 17.3569 10.8254 17.3569H10.8187Z",
    fill: "#A49992"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22394 23.5616L6.90994 24.0119V26.0384L7.95077 26.3166C7.95077 26.3166 7.35313 12.0119 25.1076 10.0715V0.0185547C25.1076 0.0185547 20.7966 0.329813 17.2846 2.05167L17.983 6.06491L16.9422 6.37617L16.2505 4.00531C16.2505 4.00531 10.7845 5.68743 7.0711 11.7669L7.99106 13.1311C7.99106 13.1311 4.57312 17.9457 4.22394 23.5616Z",
    fill: "url(#paint3_linear_4655_315073)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.278 2.05029L16.667 3.81188L17.278 6.27546L17.7414 6.13639L19.0306 9.52711L17.278 2.05029Z",
    fill: "#201B0E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06497 11.77L7.66932 13.7303L7.8842 13.3329L11.0403 16.0084L7.06497 11.77Z",
    fill: "#201B0E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22394 23.563L5.56023 25.0795L5.60052 24.755L6.90323 25.0795V24.0199L4.22394 23.563Z",
    fill: "#201B0E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2754 12.1304L15.5496 7.85889C15.5496 7.85889 12.8972 9.01783 11.0438 11.3821L13.6022 14.4152L17.2821 12.1304H17.2754Z",
    fill: "url(#paint4_linear_4655_315073)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0993 1.60693C25.0993 1.60693 21.782 2.05726 19.5056 3.01753L20.6271 8.52746L25.0993 8.07713V1.60693Z",
    fill: "url(#paint5_linear_4655_315073)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6021 11.2622C11.6021 11.2622 13.301 9.52706 15.3088 8.74561C15.3088 8.74561 16.8264 11.5933 16.8399 11.9906C16.8399 11.9906 15.188 13.2489 13.7711 13.8847L11.6021 11.2622Z",
    fill: "url(#paint6_linear_4655_315073)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98909 15.3252L9.77528 16.6298C9.77528 16.6298 8.04953 19.4312 7.06913 22.9146L5.39709 22.6497C5.39709 22.6497 5.67913 17.9477 7.98909 15.3252Z",
    fill: "url(#paint7_linear_4655_315073)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46033 16.7368L8.07704 15.75C8.07704 15.75 6.25727 17.9685 5.67978 22.2202L7.06307 22.4255C7.06307 22.4255 8.03675 19.5315 9.46033 16.7368Z",
    fill: "#201B0E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0994 2.05029C25.0994 2.05029 21.8426 2.45427 20.137 3.30857C20.137 3.30857 20.8555 8.19599 20.9764 8.20923C21.0905 8.22248 25.0994 7.85824 25.0994 7.85824V2.05029Z",
    fill: "#201B0E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9774 23.5616L43.2914 24.0119V26.0384L42.2506 26.3166C42.2506 26.3166 42.8482 12.0119 25.0938 10.0715V0.0185547C25.0938 0.0185547 29.4048 0.329813 32.9167 2.05167L32.2184 6.06491L33.2592 6.37617L33.9509 4.00531C33.9509 4.00531 39.4169 5.68743 43.1303 11.7669L42.2103 13.1311C42.2103 13.1311 45.6283 17.9457 45.9774 23.5616Z",
    fill: "url(#paint8_linear_4655_315073)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9239 2.05029L33.535 3.81188L32.9239 6.27546L32.4606 6.13639L31.1713 9.52711L32.9239 2.05029Z",
    fill: "#201B0E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1372 11.77L42.5329 13.7303L42.3247 13.3329L39.162 16.0084L43.1372 11.77Z",
    fill: "#201B0E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9756 23.563L44.646 25.0795L44.599 24.755L43.2963 25.0795V24.0199L45.9756 23.563Z",
    fill: "#201B0E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9236 12.1304L34.6494 7.85889C34.6494 7.85889 37.3018 9.01783 39.1552 11.3821L36.5967 14.4152L32.9169 12.1304H32.9236Z",
    fill: "url(#paint9_linear_4655_315073)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1005 1.60693C25.1005 1.60693 28.4177 2.05726 30.6941 3.01753L29.5727 8.52746L25.1005 8.07713V1.60693Z",
    fill: "url(#paint10_linear_4655_315073)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5998 11.2622C38.5998 11.2622 36.9009 9.52706 34.8931 8.74561C34.8931 8.74561 33.3756 11.5933 33.3621 11.9906C33.3621 11.9906 35.014 13.2489 36.4309 13.8847L38.5998 11.2622Z",
    fill: "url(#paint11_linear_4655_315073)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2108 15.3252L40.4247 16.6298C40.4247 16.6298 42.1504 19.4312 43.1308 22.9146L44.8028 22.6497C44.8028 22.6497 44.5208 17.9477 42.2108 15.3252Z",
    fill: "url(#paint12_linear_4655_315073)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7403 16.7368L42.1236 15.75C42.1236 15.75 43.9434 17.9685 44.5209 22.2202L43.1376 22.4255C43.1376 22.4255 42.1639 19.5315 40.7403 16.7368Z",
    fill: "#201B0E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1005 2.05029C25.1005 2.05029 28.3573 2.45427 30.0629 3.30857C30.0629 3.30857 29.3444 8.19599 29.2235 8.20923C29.1094 8.22248 25.1005 7.85824 25.1005 7.85824V2.05029Z",
    fill: "#201B0E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.243 4.0127L17.7404 6.13852L16.9346 6.38356L16.243 4.0127Z",
    fill: "#614E43"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9328 4.11865L32.4622 6.13852L33.268 6.38355L33.9328 4.11865Z",
    fill: "#614E43"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1476 25.0734L40.738 30.3913L43.5986 36.0933L45.9757 31.5304L43.6254 28.1794L47.6544 26.3184L46.9964 21.5635L41.1476 25.0734Z",
    fill: "url(#paint13_linear_4655_315073)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6528 26.3193L44.7452 28.8293V28.3657L43.6237 28.1803L47.6528 26.3193Z",
    fill: "#BD7A1B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5978 36.0926L42.0063 37.5694L42.6174 36.2714L41.1468 31.5694H39.6628L39.1592 30.8012L39.2465 25.2449L41.1468 25.0728L40.7372 30.3906L43.5978 36.0926Z",
    fill: "#201B0E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9955 21.5656L45.7062 21.4663L45.7868 21.9034L42.0936 24.1948L39.8575 24.4332L39.2464 25.2478L41.1467 25.0756L46.9955 21.5656Z",
    fill: "#614E43"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7609 26.9243L45.6932 31.123L43.8735 28.5336C43.8735 28.5336 45.4381 27.4541 46.7609 26.9243Z",
    fill: "url(#paint14_linear_4655_315073)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.148 25.0768L40.2079 25.1629C40.2079 25.1629 41.0204 24.4477 41.8464 24.2225C42.6723 23.9973 44.2839 23.2026 44.2839 23.2026L41.1547 25.0768H41.148Z",
    fill: "#74645A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07914 25.0734L9.48876 30.3913L6.62816 36.0933L4.25105 31.5304L6.6013 28.1794L2.5723 26.3184L3.23037 21.5635L9.07914 25.0734Z",
    fill: "url(#paint15_linear_4655_315073)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5723 26.3193L5.4799 28.8293V28.3657L6.60131 28.1803L2.5723 26.3193Z",
    fill: "#BD7A1B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62888 36.0926L8.22705 37.5694L7.60927 36.2714L9.07986 31.5694H10.5639L11.0675 30.8012L10.9802 25.2449L9.07986 25.0728L9.48947 30.3906L6.62888 36.0926Z",
    fill: "#201B0E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2319 21.5656L4.52119 21.4663L4.44061 21.9034L8.13386 24.1948L10.37 24.4332L10.981 25.2478L9.08068 25.0756L3.2319 21.5656Z",
    fill: "#614E43"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46512 26.9243L4.53281 31.123L6.35258 28.5336C6.35258 28.5336 4.78798 27.4541 3.46512 26.9243Z",
    fill: "url(#paint16_linear_4655_315073)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07927 25.0768L10.0194 25.1629C10.0194 25.1629 9.20686 24.4477 8.38091 24.2225C7.55496 23.9973 5.94336 23.2026 5.94336 23.2026L9.07256 25.0768H9.07927Z",
    fill: "#74645A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6413 12.1972C33.4331 11.727 33.6547 11.2039 35.3133 10.9588C36.9652 10.7138 36.5825 12.8065 36.3676 13.2833C36.146 13.7535 33.648 12.2039 33.648 12.2039L33.6413 12.1972Z",
    fill: "#FF2515"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7734 13.7347C13.3705 13.589 12.9475 12.1188 14.2636 10.9598C15.5865 9.80089 16.5132 11.3638 16.5467 11.8737C16.5803 12.3837 13.7734 13.7347 13.7734 13.7347Z",
    fill: "#FF2515"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56702 11.5563C7.56702 11.5563 9.89041 11.0795 12.0929 9.80796C14.2955 8.53644 16.2428 4.47021 16.2428 4.47021C16.2428 4.47021 10.8305 5.98015 7.56702 11.5563Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3454 2.33284C17.3454 2.33284 22.0795 1.53814 25.108 1.59774C28.1297 1.65734 31.7693 2.74343 31.917 2.74343C32.0647 2.74343 32.8773 2.27986 32.8773 2.27986C32.8773 2.27986 28.9154 0.15403 25.108 0.213633C21.3006 0.273235 17.3454 2.32622 17.3454 2.32622V2.33284Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2529 4.11865C34.2529 4.11865 34.9714 6.37031 36.1398 7.69481C37.3082 9.01932 42.2572 11.3836 42.2572 11.3836C42.2572 11.3836 41.6058 7.74779 34.2529 4.11865Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.242 4.47412C16.242 4.47412 14.3349 5.22247 13.368 6.16948C12.401 7.1165 12.2264 9.72578 12.2264 9.72578C12.2264 9.72578 15.8257 5.84498 16.242 4.47412Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6399 2.29279C17.6399 2.29279 19.1441 1.43848 21.266 0.835834C23.3879 0.233185 25.6106 0.226562 25.6106 0.226562C25.6106 0.226562 25.0801 1.03451 23.0858 1.48484C21.0847 1.93517 17.6399 2.28616 17.6399 2.28616V2.29279Z",
    fill: "#A49992"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2529 4.11865C34.2529 4.11865 36.7509 5.11865 37.4626 5.95971C38.1744 6.80077 38.5505 9.42329 38.5505 9.42329C38.5505 9.42329 35.3206 7.56236 34.2529 4.12527V4.11865Z",
    fill: "#A49992"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2491 6.38056C35.2491 6.38056 35.5311 6.19513 35.981 6.89711C36.4376 7.5991 36.1422 7.5395 36.1422 7.5395C36.1422 7.5395 35.5445 7.67195 35.2491 6.38056Z",
    fill: "#705F55"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1783 2.11153C19.1783 2.11153 18.9298 1.58173 19.9035 1.48239C20.8772 1.38306 21.2667 1.84001 21.2667 1.84001C21.2667 1.84001 21.3338 2.28372 19.185 2.11153H19.1783Z",
    fill: "#705F55"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8116 35.8865C38.2676 35.7673 37.6163 36.8534 38.0662 37.6679C38.5094 38.4759 40.0471 36.1514 38.8116 35.8865Z",
    fill: "#201B0E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0383 36.6781C38.0383 37.3006 38.8374 37.2741 39.1127 36.9298C39.3947 36.5788 39.3208 35.8503 38.7366 35.8834C38.1457 35.9165 38.0383 36.6781 38.0383 36.6781Z",
    fill: "#72BE2F"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9254 37.2177C38.0664 36.8336 38.57 37.2508 38.8587 37.2508C39.1475 37.2508 38.7043 37.8932 38.3685 37.8336C38.0328 37.7674 37.9254 37.2177 37.9254 37.2177Z",
    fill: "#614E43"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84482 27.4271C8.34119 27.6523 8.46878 28.904 9.32158 29.2947C10.161 29.6854 9.9998 26.9106 8.84482 27.4271Z",
    fill: "#201B0E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7044 28.5054C9.08044 29.002 9.70493 28.5186 9.71836 28.0749C9.73179 27.6312 9.23488 27.0815 8.78498 27.4524C8.32835 27.8232 8.7044 28.5054 8.7044 28.5054Z",
    fill: "#72BE2F"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93867 29.0146C8.8178 28.6239 9.47587 28.6636 9.70418 28.4914C9.93249 28.3193 9.96607 29.1007 9.66389 29.2464C9.355 29.3921 8.93867 29.0146 8.93867 29.0146Z",
    fill: "#614E43"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8197 38.4121C12.8197 38.4121 18.8766 42.6306 25.4238 42.5048C31.9776 42.379 37.6384 38.1538 37.6384 38.1538C37.6384 38.1538 33.5624 43.0942 25.914 43.8359C18.2656 44.5777 12.813 38.4121 12.813 38.4121H12.8197Z",
    fill: "#614E43"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4267 13.6759C16.4267 13.6759 18.7904 11.4309 22.8194 10.7819C26.8484 10.1329 29.8097 12.0534 29.8097 12.0534C29.8097 12.0534 27.6945 10.8878 23.1216 11.5567C18.5486 12.2256 16.4334 13.6759 16.4334 13.6759H16.4267Z",
    fill: "#705F55"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2455 43.5595C28.2455 43.5595 28.5073 42.7383 30.5688 41.8112C32.6304 40.884 35.1552 40.3608 35.1552 40.3608C35.1552 40.3608 31.3746 43.2681 28.2455 43.5661V43.5595Z",
    fill: "#705F55"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7964 40.3542L32.6068 39.9502C28.242 41.9568 25.227 41.8111 25.227 41.8111C25.227 41.8111 21.6479 42.2217 17.8472 39.9502L14.6575 40.3542C14.6575 40.3542 16.1147 47.8972 16.8399 48.6389C16.8399 48.6389 21.3121 49.5727 25.4284 49.5727C29.5447 49.5727 34.2519 48.5197 34.2519 48.5197C34.6146 47.4138 35.7964 40.3608 35.7964 40.3608V40.3542Z",
    fill: "url(#paint17_linear_4655_315073)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8472 39.9502C17.8472 39.9502 22.4268 41.8111 25.227 41.8111C28.0271 41.8111 32.6068 39.9502 32.6068 39.9502L35.7964 40.3542C35.7964 40.3542 30.881 42.2019 25.4217 42.2019C19.9624 42.2019 14.6575 40.3542 14.6575 40.3542L17.8472 39.9502Z",
    fill: "#614E43"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4314 42.4336C16.4314 42.4336 27.8805 43.7117 34.5485 41.9634C34.5485 41.9634 34.3337 45.8376 33.8367 47.7382C33.8367 47.7382 27.0747 50.023 17.4588 47.9104C17.4588 47.9104 16.4247 45.0627 16.4314 42.4336Z",
    fill: "url(#paint18_linear_4655_315073)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.018 42.7285C17.018 42.7285 27.7351 43.8808 33.9734 42.3047C33.9734 42.3047 33.7719 45.7881 33.3086 47.4901C33.3086 47.4901 26.9831 49.5431 17.9849 47.6491C17.9849 47.6491 17.018 45.0928 17.0247 42.7285H17.018Z",
    fill: "#201B0E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4209 42.2038C25.4209 42.2038 28.2009 41.4422 29.6514 41.0779C31.1018 40.7137 34.9294 40.6475 34.9294 40.6475C34.9294 40.6475 30.0274 42.1905 25.4209 42.2038Z",
    fill: "#705F55"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4829 48.7867C26.4829 48.7867 27.3156 48.5946 29.1488 48.2635C30.982 47.939 33.0435 47.9522 33.0435 47.9522C33.0435 47.9522 29.9882 48.6939 26.4829 48.7867Z",
    fill: "#705F55"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66806 33.2456C9.66806 33.2456 10.1314 34.8019 11.1588 36.239C11.1588 36.239 10.5746 34.6496 9.66806 33.2456Z",
    fill: "#705F55"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22632 37.5773C8.22632 37.5773 10.637 37.2197 11.9934 37.9879C13.3499 38.7561 14.9145 41.617 14.9145 41.617L15.5658 44.5971C15.5658 44.5971 11.1339 42.1932 8.2196 37.5773H8.22632Z",
    fill: "#74742F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1569 44.3065C35.1569 44.3065 35.7545 40.9025 36.0231 40.3594C36.2917 39.8098 41.375 37.4521 41.375 37.4521C41.375 37.4521 38.9911 41.1872 38.0846 42.2071C37.1781 43.227 35.1501 44.3131 35.1501 44.3131L35.1569 44.3065Z",
    fill: "#74742F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58478 30.911C4.58478 30.911 4.41691 30.0567 4.74594 29.5004C5.07498 28.9441 6.14938 28.6328 6.14938 28.6328L4.5915 30.911H4.58478Z",
    fill: "#FF2515"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1985 28.6241C44.1985 28.6241 45.0379 28.591 45.4677 29.0281C45.8974 29.4652 45.696 31.1274 45.696 31.1274L44.1985 28.6241Z",
    fill: "#FF2515"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M13.4508 10.0739C15.425 8.68975 17.7014 8.49769 18.534 9.65663C19.3667 10.809 18.44 12.8752 16.4658 14.2593C14.4916 15.6434 12.2152 15.8354 11.3825 14.6765C10.5499 13.5242 11.4765 11.458 13.4508 10.0739Z",
    fill: "url(#paint19_radial_4655_315073)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M33.3267 8.42171C35.2002 7.10383 37.7989 7.54092 39.1352 9.3886C40.4715 11.2363 40.0283 13.7992 38.1548 15.1171C36.2813 16.435 33.6826 15.9979 32.3463 14.1502C31.01 12.3025 31.4532 9.73959 33.3267 8.42171Z",
    fill: "url(#paint20_radial_4655_315073)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 33H24V20H26.5V33Z",
    fill: "#E9B267"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315073",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0001 25.3529) scale(25 24.6556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F98500",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315073",
    x1: 25.1141,
    y1: 47.0245,
    x2: 25.1141,
    y2: 8.20996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315073",
    x1: 25.1129,
    y1: 43.852,
    x2: 25.1129,
    y2: 11.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315073",
    x1: 14.6591,
    y1: 26.3232,
    x2: 14.6591,
    y2: 0.0185547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315073",
    x1: 14.1529,
    y1: 14.4152,
    x2: 14.1529,
    y2: 7.85889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E372D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315073",
    x1: 22.2991,
    y1: 8.52746,
    x2: 22.2991,
    y2: 1.60693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315073",
    x1: 14.7851,
    y1: 13.6132,
    x2: 13.5809,
    y2: 9.22704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315073",
    x1: 7.57947,
    y1: 22.9146,
    x2: 7.57947,
    y2: 15.3252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315073",
    x1: 35.5356,
    y1: 26.3232,
    x2: 35.5356,
    y2: 0.0185547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315073",
    x1: 36.0394,
    y1: 14.4152,
    x2: 36.0394,
    y2: 7.85889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A77740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3E372D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315073",
    x1: 27.894,
    y1: 8.52746,
    x2: 27.894,
    y2: 1.60693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315073",
    x1: 35.4169,
    y1: 13.6132,
    x2: 36.621,
    y2: 9.22704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315073",
    x1: 42.6137,
    y1: 22.9146,
    x2: 42.6137,
    y2: 15.3252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315073",
    x1: 44.1962,
    y1: 36.0933,
    x2: 44.1962,
    y2: 21.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315073",
    x1: 46.2372,
    y1: 30.9773,
    x2: 45.2359,
    y2: 27.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315073",
    x1: 6.03053,
    y1: 36.0933,
    x2: 6.03053,
    y2: 21.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315073",
    x1: 3.98889,
    y1: 30.9773,
    x2: 4.99016,
    y2: 27.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB74D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315073",
    x1: 25.227,
    y1: 49.5727,
    x2: 25.227,
    y2: 39.9502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315073",
    x1: 25.49,
    y1: 48.8044,
    x2: 25.49,
    y2: 41.9634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191407"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4655_315073",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6697 12.786) rotate(-125.806) scale(2.58591 4.36005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F95F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B84600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#803000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#521F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2E1100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#140700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4655_315073",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9478 10.4211) rotate(-125.806) scale(4.11547 4.13388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F95F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B84600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#803000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#521F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2E1100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#140700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#050200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_315073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeLeague);
export default __webpack_public_path__ + "static/media/bronze-league.f7c104b4f814f775d2e0159ae21057b9.svg";
export { ForwardRef as ReactComponent };